import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { COMPANY, SITE_URL, SUPPORT_EMAIL } from '../data/launch';
export function TermsAndConditions() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-731" data-mp="2amizminws68d">
      <SEO title="Terms of Use | KittyPot" description="The terms for using the KittyPot app and website. KittyPot helps groups track shared expenses and settle up directly; it does not hold or move money." ogTitle="KittyPot Terms of Use" ogDescription="The terms for using the KittyPot app and website." path="/terms" data-id="element-732" data-mp="20q5vsryngbzw" />
      <Navbar data-id="element-733" data-mp="3q4ayu0vnodvi" />
      <main className="pt-32 pb-24" data-id="element-734" data-mp="3q2rjqdlqk8vb">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-735" data-mp="3m38ythtwzxsh">
          <h1 className="text-4xl font-black text-kitty-dark mb-4" data-id="element-736" data-mp="3m1o5twn90mwq">
            Terms of Use
          </h1>
          <p className="text-gray-500 font-medium mb-10" data-id="element-737" data-mp="2u3nx1quzawp3">
            Last updated: 26 August 2026
          </p>

          <div className="prose prose-gray max-w-none text-gray-600 space-y-6" data-id="element-738" data-mp="2g4eggq2v20kl">
            <p data-id="element-739" data-mp="2k5hvxbgzxula">
              These terms apply when you use the KittyPot app or {SITE_URL} (the
              “Service”), provided by {COMPANY.legalName} (company number{' '}
              {COMPANY.registrationNumber}), referred to as “KittyPot”, “we” or
              “us”. By using the Service you agree to these terms.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-740" data-mp="2z1pg4bsemw0k">
              1. What KittyPot does
            </h2>
            <p data-id="element-741" data-mp="332j3n41xq8sx">
              KittyPot helps groups record shared expenses, split costs between
              members, and keep track of who owes what. It is a record-keeping
              tool.
            </p>
            <p data-id="element-742" data-mp="3vmrezww7qkm2">
              To be clear about what KittyPot is not: we do not hold your money,
              we do not operate a wallet or store group funds, and we do not
              transfer money between members. We are not a bank and we are not a
              payment service provider. Any payment between you and another
              member happens directly between you, outside KittyPot. We are not
              a party to it, we cannot guarantee that anyone will pay, and we do
              not adjudicate disputes between members of a kitty.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-743" data-mp="3hphryq5hwn3f">
              2. Your account
            </h2>
            <p data-id="element-744" data-mp="3dnd1u1e9a8lj">
              You need an account to use the full app. You must give accurate
              details, keep your sign-in secure, and let us know if you think
              someone else has access to your account. You are responsible for
              activity carried out under your account.
            </p>
            <p data-id="element-745" data-mp="2oo9x3zjibd1d">
              <strong data-id="element-746" data-mp="2oors6sufnl7p">Age requirements.</strong> You must be at least 13 years
              old to create or use a KittyPot account. If you are under 18, you
              should only use KittyPot where you have the permission of a parent
              or guardian where required by applicable law.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-747" data-mp="33khg4wj6i8f2">
              3. Acceptable use
            </h2>
            <p data-id="element-748" data-mp="25zbpbyv9zgo4">When using KittyPot, you agree not to:</p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-749" data-mp="2awbwkd3v2pgt">
              <li data-id="element-750" data-mp="2aur02hxzkwgb">use the Service for anything unlawful or fraudulent</li>
              <li data-id="element-751" data-mp="2fv6cn7ag1zx8">
                add someone to a kitty, or upload information about them,
                without a good reason to do so
              </li>
              <li data-id="element-752" data-mp="1n7it7vkwtfc6">
                harass other members, or use expense descriptions and
                notifications to send abusive content
              </li>
              <li data-id="element-753" data-mp="1s4iyi49xqe28">
                attempt to disrupt the Service, access it without authorisation,
                or interfere with other people's data
              </li>
            </ul>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-754" data-mp="3oy15ahlpeqy1">
              4. Creating and joining kitties
            </h2>
            <p data-id="element-755" data-mp="2p89o1vi5n9y">
              You can create a kitty and invite others by link, code, QR or from
              your contacts, and people can take part from the app or from their
              browser. Members of a kitty can see that kitty's expenses,
              balances and settlement records. Only add people who should see
              that information.
            </p>
            <p data-id="element-756" data-mp="qcq6wcxjddkb">
              A kitty may have one or more admins who can manage members, rename
              the kitty and close it. Admin roles are held by members using the
              app so that a kitty always has someone able to manage it.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-757" data-mp="2n8e8cnkd5kes">
              5. Expenses, balances and accuracy
            </h2>
            <p data-id="element-758" data-mp="12rej832ihnr0">
              Everything KittyPot shows is calculated from information that you
              and other members enter. We do not verify amounts, and we cannot
              confirm that an expense really happened or that a split is fair.
              It is your responsibility to check that the amounts, payers and
              splits are right.
            </p>
            <p data-id="element-759" data-mp="jx9a8118w28v">
              An expense cannot be edited once it has been added. If the
              details are wrong, a member with permission in that kitty can
              delete the expense and add it again correctly, and balances are
              worked out again from the remaining entries.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-760" data-mp="f1aoymb7r0co">
              6. Receipts
            </h2>
            <p data-id="element-761" data-mp="29d8nnubwcdub">
              You can attach a receipt image to an expense. Where the app reads
              details from a receipt automatically, those details are a
              suggestion and may be wrong or incomplete. Always check them
              before saving. Only upload receipts you are entitled to share with
              the group.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-762" data-mp="1y08cqiiwqpqx">
              7. Settling up
            </h2>
            <p data-id="element-763" data-mp="2qmtdg9l9we75">
              Settlement in KittyPot is a record, not a payment. When you mark
              an amount as paid, you are telling the group that you have paid it
              elsewhere, and the person receiving it can confirm they got it.
              Disputes about whether a payment was actually made are between the
              members concerned.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-764" data-mp="2ctln0l8xhor1">
              8. Currencies
            </h2>
            <p data-id="element-765" data-mp="34muf3r9d3pno">
              Each kitty runs in its own currency, and every expense in it is
              recorded in that currency. You can set a display currency for your
              own account, which is used to show estimated totals in My Balance;
              it does not change the currency a kitty runs in or any recorded
              amount. Converted amounts are estimates for presentation only, and
              may not match the rate your bank or payment provider uses at the
              time you settle.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-766" data-mp="1a2107hcspj8t">
              9. Sharing bank details
            </h2>
            <p data-id="element-767" data-mp="1ezsnfy2hwh6o">
              You may choose to save bank details so they are easy to share when
              your group settles up. This is optional, and you decide whether to
              share them. Where you do, they may be shown to the other members
              who have joined that kitty so they can pay you back; people still
              waiting to join do not receive them. KittyPot does not use them to
              make or start a payment. Please take the same care you would take
              anywhere else when sharing account details, and check payment
              instructions before you send money.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-768" data-mp="1hqfo5xhu1mv2">
              10. Your content
            </h2>
            <p data-id="element-769" data-mp="1dpnex48ynhys">
              You keep ownership of the content you add, such as expense
              descriptions and receipt images. You give us permission to store
              and process that content, and to show it to the other members of
              the relevant kitty, so that we can provide the Service.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-770" data-mp="yt65iikc0dev">
              11. Our intellectual property
            </h2>
            <p data-id="element-771" data-mp="6a8vliw10x9o">
              The KittyPot name, logo, app and website, including their design
              and software, belong to {COMPANY.legalName}. You may use them only
              as part of using the Service.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-772" data-mp="3o91s77d39qij">
              12. Availability and changes
            </h2>
            <p data-id="element-773" data-mp="3t362o0lkcgod">
              We work to keep KittyPot available and running well, but we cannot
              promise it will be available without interruption. We may update,
              change or withdraw features, and we will give reasonable notice of
              significant changes where we can.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-774" data-mp="fvcojzymwodw">
              13. Suspension and ending your account
            </h2>
            <p data-id="element-775" data-mp="x0pxnrpb5k3">
              You can delete your account at any time, see{' '}
              <Link to="/delete-account" className="font-semibold text-kitty-dark underline underline-offset-2 hover:text-kitty-yellow-700" data-id="element-776" data-mp="5vlprm31jn80">
                Delete your KittyPot account
              </Link>
              . We may suspend or end access if these terms are seriously or
              repeatedly broken, or where we are required to by law. We will
              tell you why unless we are prevented from doing so.
            </p>
            <p data-id="element-777" data-mp="1eb392ozjqwng">
              When an account is deleted, we remove or anonymise the account
              information described in our{' '}
              <Link to="/privacy-policy" className="font-semibold text-kitty-dark underline underline-offset-2 hover:text-kitty-yellow-700" data-id="element-778" data-mp="1j7bn1z20cjt1">
                Privacy Policy
              </Link>
              . The account can no longer be used to sign in. Shared expense,
              settlement and membership records may be kept, including a
              historical display name and receipts attached to shared expenses,
              so other members' records stay accurate.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-779" data-mp="2up37twmnog94">
              14. Our responsibility to you
            </h2>
            <p data-id="element-780" data-mp="j1rcou1zgi6n">
              We provide KittyPot with reasonable care and skill. We are
              responsible for loss you suffer that is a foreseeable result of us
              breaking these terms or failing to use reasonable care and skill.
            </p>
            <p data-id="element-781" data-mp="nzsz9oymazmv">
              We are not responsible for loss that is not foreseeable, for money
              another member fails to pay you, or for decisions you make based
              on figures entered by members. Nothing in these terms limits our
              liability for death or personal injury caused by our negligence,
              for fraud, or for anything else that cannot be limited by law.
              Nothing in these terms affects your legal rights as a consumer.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-782" data-mp="3dggu10gedhia">
              15. Changes to these terms
            </h2>
            <p data-id="element-783" data-mp="38k04c1tjuv33">
              We may update these terms as the Service develops. If a change
              materially affects you, we will give reasonable notice. Continuing
              to use KittyPot after a change means you accept the updated terms.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-784" data-mp="1lenu5vvq1wj3">
              16. Governing law
            </h2>
            <p data-id="element-785" data-mp="1qgd4taf1886n">
              These terms are governed by the law of England and Wales, and the
              courts of England and Wales have jurisdiction. If you live
              elsewhere in the UK, you may bring proceedings in your local
              courts.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-786" data-mp="254zmhis4tc11">
              17. Contact us
            </h2>
            <p data-id="element-787" data-mp="294i4o6skj906">
              Questions about these terms? Email{' '}
              <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-kitty-dark underline underline-offset-2 hover:text-kitty-yellow-700" data-id="element-788" data-mp="2e5fm2h5r7z0m">
                {SUPPORT_EMAIL}
              </a>{' '}
              or write to us:
            </p>
            <address className="not-italic" data-id="element-789" data-mp="2o79t77klwukm">
              {COMPANY.addressLines.map(line => <React.Fragment key={line} data-id="element-790" data-mp="2ja9mcufxnnsg">
                  {line}
                  <br data-id="element-791" data-mp="2f7wk4g0ea80f" />
                </React.Fragment>)}
            </address>
          </div>
        </div>
      </main>
      <Footer data-id="element-792" data-mp="3bwknc67gbqps" />
    </div>;
}